import Http from "../../http/client";

export default async (id) => {
  const response = await Http.delete('admin/sessions/'+id);
  return response.data;
}
